<template>
  <Transition
    enter-active-class="duration-300 ease-bounce"
    enter-from-class="translate-x-full"
    enter-to-class="translate-x-0"
    leave-active-class="duration-300 ease-bounce"
    leave-from-class="translate-x-0"
    leave-to-class="translate-x-full"
  >
    <div
      v-if="open"
      class="absolute inset-y-0 right-0 flex flex-col overflow-hidden overflow-y-auto border-border bg-background transition-all motion-reduce:transition-none"
      :class="drawerWidthClass"
      style="box-shadow: -4px 0px 12px rgba(0, 0, 0, 0.1)"
    >
      <DrawerPortal.Outlet />
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from "vue";

import * as DrawerPortal from "@/design_system/Drawer/Portal";
import { useMediaQuery } from "@/lib/media_query";

const isMobile = useMediaQuery("(width < 640px)");
const open = DrawerPortal.useIsPortalOpen();

const drawerVariant = ref<string>("default");

const updateVariant = () => {
  const drawerContent = document.querySelector("[data-drawer-variant]");
  if (drawerContent) {
    drawerVariant.value =
      drawerContent.getAttribute("data-drawer-variant") || "default";
  }
};

onMounted(() => {
  updateVariant();
  const observer = new MutationObserver(updateVariant);
  observer.observe(document.body, { childList: true, subtree: true });
  onUnmounted(() => observer.disconnect());
});

const drawerWidthClass = computed(() => {
  if (isMobile.value) {
    return "w-full";
  }

  switch (drawerVariant.value) {
    case "wide":
      return "w-[40rem] border-l";
    case "very-wide":
      return "w-[50rem] border-l";
    default:
      return "w-[30rem] border-l";
  }
});
</script>
